<template>
	<div>
		<div>
			<b-button :variant="(tab == 'params') ? 'success' : 'secondary'" @click="tab = 'params'">Caractéristiques</b-button>&nbsp;
			<b-button :variant="(tab == 'scenario') ? 'success' : 'secondary'" @click="tab = 'scenario'">Scénario</b-button>&nbsp;
			<br /><br />
		</div>

		<div v-show="tab == 'params'">
			<p><b>Données</b></p>

			<b-select v-model="type_data_test" :options="[
				{value: 'filters_tabulator', text: 'Tableau'},
				{value: 'database', text: 'Base de données'},
				{value: 'DatabaseRequestView', text: 'Base de données - multitables'},
			]" />

			<br /><br />

			<div v-if="type_data_test == 'tabulator'">
				<edit_tabulator @update="import_file" ref="tabulator"></edit_tabulator>
			</div>
			
			<div v-if="type_data_test == 'filters_tabulator'">
				<filters_tabulator @update="import_file" ref="tabulator"></filters_tabulator>
			</div>

			<DatabaseRequestView v-if="type_data_test == 'DatabaseRequestView'"
				@update="import_file"
				_type="db"
				:minimal="true"
				ref="tabulator" />

			<div v-if="type_data_test == 'database'">
				<database
					@update="import_file"
					:change_table="true"
					:name="false"
					:edit="false"
					start_table="prevalidation"
					ref="tabulator"></database>
			</div>

			<p>Ajouter une caractéristique</p>

			<b-select v-model="new_characteristic" :options="type_characteristics"></b-select><br /><br />

			<b-button @click="add">Ajouter</b-button><br /><br />

			<b-container style="margin: 0; padding: 0; max-width: none">
				<b-row
					ref="div_row"
					style="
						flex-wrap: nowrap !important;
						margin: 0;
						padding: 0;
						max-width: none;
					">
					<b-col
						ref="div_menu"
						md="auto"
						style="margin: 0; padding: 0; max-width: none">
						<draggable :group="id" :list="characteristics" class="list-group">
							<div v-for="(characteristic, idx) in characteristics" :key="idx">
								<b-button :style="'font-weight:' + ((characteristic_idx == idx) ? 'bold' : 'normal')" @click="characteristic_idx = idx" variant="link">{{characteristic.name}}</b-button>
							</div>
						</draggable>
					</b-col>
					<b-col>
						<b-card v-show="characteristic_idx == idx" v-for="(characteristic, idx) in characteristics" :key="idx">
							<characteristic :ref="'characteristic' + idx" @update="update($event, idx)"></characteristic>
							<b-button variant="link" @click="refresh(idx)"><i class="fas fa-sync-alt"></i></b-button>
							<b-button variant="link" @click="del(idx)"><i class="fas fa-trash"></i></b-button>
						</b-card>
					</b-col>
				</b-row>
			</b-container>

			<br />
			<b-button @click="test">Test de toutes les caractéristiques</b-button>

			<br /><br />

			<div v-if="is_test">
				Traitement en cours des lignes {{test_start}} à {{test_end}} sur {{test_data.length}}
			</div>

			<div v-if="is_test && !stop_file">
				<b-button v-if="!stop_file" @click="stop_file = true" variant="danger">Arrêter le test</b-button>
			</div>

			<br /><br />

			<edit_tabulator ref="export_tabulator" :extern_file="false"></edit_tabulator>
		</div>

		<div v-show="tab == 'scenario'">

			<project
				ref="scenario"
				initial_method_prop="fichiers"
				:config="false"
				:config_name="true"
				state_prop="etape"></project>
		</div>

	</div>
</template>

<script>
	import * as json2csv from "json2csv";
	import draggable from "vuedraggable";
	import uniqueId from "lodash.uniqueid";
	
	var clone = require("clone");
	var jp = require('jsonpath');

	import filters_tabulator from "../components/filters_tabulator.vue";
	import DatabaseRequestView from '../views/DatabaseRequestView.vue';
	import edit_tabulator from "../components/edit_tabulator.vue";
	import characteristic from "../components/characteristic.vue";
    import treatments from "../services/treatments.js";
	import databaseView from "../views/database.vue";	
	import library from "../services/library.js";
	import project from "./Project.vue";

	export default {
		name: "characteristics",
		components: {
			draggable,
			edit_tabulator,
			database: databaseView,
			DatabaseRequestView,
			characteristic,
			project,
			filters_tabulator
		},
		props: {
			version: {
				default: ""
			},
			name: {
				default: ""
			}
		},
		data() {
			return {
				id: uniqueId(""),
				type_data_test: "filters_tabulator",
				test_data: [],
				type_characteristics: [],
				new_characteristic: "",
				characteristics: [],
				tab: "params",
				is_test: false,
				stop_file: false,
				test_start: 0,
				test_end: 0,
				characteristic_idx: 0
			};
		},
		watch: {
		},
		methods: {
			async update(obj, idx)
			{
				this.$set(this.characteristics, idx, obj);
			},
			async add()
			{
				var self = this;
				if (!this.new_characteristic)
					return;

				var result = await library.load(
					this.new_characteristic,
					null,
					"config_characteristic"
				);

				console.log(result)

				this.new_characteristic = "";

				this.characteristics.push({name: "Caratéristique " + (this.characteristics.length + 1)});
				this.characteristic_idx = this.characteristics.length - 1;
				self.$nextTick(async function () {
					self.$refs['characteristic' + (this.characteristics.length - 1)][0].load({config: result, type: this.new_characteristic, name: "Caratéristique " + this.characteristics.length});
					self.$refs['characteristic' + (this.characteristics.length - 1)][0].set_import_data(this.test_data.slice(0, 10));
                });
			},
            del(idx)
            {
                this.characteristics.splice(idx, 1);
			},
			refresh(idx)
			{
				this.$refs['characteristic' + idx][0].refresh_config();
			},
			async load(data)
			{
				var self = this;

				this.characteristics = data.characteristics;
				this.type_data_test = data.type_data_test;

				this.characteristic_idx = 0;

				self.$nextTick(async function () {

					console.log(self.name + " - " + self.version)

					await self.$refs.scenario.load_db(
						self.name,
						self.version
					);

					console.log(data.test_data)

                    if (data.test_data)
                    { 
                        await self.$refs.tabulator.load(data.test_data);
					}
					for (var i = 0; i < self.characteristics.length; i++)
					{
						await self.$refs['characteristic' + i][0].load(self.characteristics[i]);
						await self.$refs['characteristic' + i][0].set_import_data(self.test_data.slice(0, 10));
					}
                });
			},
			async save()
			{	
				var test_data = await this.$refs.tabulator.save();
				var steps = [];

				for (var i = 0; i < this.characteristics.length; i++)
				{
					this.characteristics[i] = await this.$refs['characteristic' + i][0].save();
					var steps = steps.concat(this.$refs['characteristic' + i][0].get_steps());
				}

				console.log(steps);

				var data = {
					type_data_test: this.type_data_test,
					test_data: test_data,
					characteristics: this.characteristics
				}

				this.$refs.scenario.update_name(this.name);
				this.$refs.scenario.set_version(this.version);

				this.$refs.scenario.deleteStepByDescription("Carac ", true);

				for (var i = steps.length - 1; i >= 0; i--)
				{
					await this.$refs.scenario.addStep(steps[i], true);
				}

				await this.$refs.scenario.save_db(false, false);

				return data;
			},
			async import_file()
			{
				this.test_data = this.$refs.tabulator.get_data();
				this.test_data = clone(this.test_data)

				console.log(this.test_data)

				for (var i = 0; i < this.characteristics.length; i++)
				{
					await this.$refs['characteristic' + i][0].set_import_data(this.test_data.slice(0, 10));
				}
			},
			async test()
			{
				this.$refs.export_tabulator.load([]);
				this.is_test = true;

				var nb = 10;
				this.test_start = 0;
				this.test_end = 0;
				for (var j = 0; j < this.test_data.length / nb && !this.stop_file; j++)
				{
					this.test_start = (j * nb) + 1;
					this.test_end = ((j + 1) * nb);
					if (this.test_end > this.test_data.length)
						this.test_end = this.test_data.length;
					console.log((j * nb) + " " + (this.test_data.length / nb))
					var data = clone(this.test_data.slice((j * nb), ((j + 1) * nb)));
					console.log(data)
					for (var i = 0; i < this.characteristics.length; i++)
					{
						await this.$refs['characteristic' + i][0].set_import_data(data);
						data = await this.$refs['characteristic' + i][0].test();
					}
					if (j == 0)
						this.$refs.export_tabulator.load(data);
					else
						this.$refs.export_tabulator.add_data(data);
				}

				this.is_test = false;
				this.stop_file = false;
			}
		},
		mounted: async function () {

			var results = await library.getby_production(
                "config_characteristic"
			);

			for (var i = 0; i < results.element.length; i++)
			{
				this.type_characteristics.push(results.element[i].name);
			}
		},
	};
</script>

<style>
</style>
